import React from "react";
import { connect } from "react-redux";
import { Button, List } from "devextreme-react";
import { lastStep, doSendPrestacionEconomica, setStep } from "../../actions";

import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import RadioGroupfield from "../../../../../../Shared/fields/RadioGroupField";
import DateField from "../../../../../../Shared/fields/DateField";

class EnviarDocumento extends React.PureComponent {
  handleBack = () => {
    const step = 3;
    this.props.dispatch(setStep(step));
    this.props.dispatch(lastStep());
  }

  handleNext = () => {
    this.props.dispatch(doSendPrestacionEconomica(this.props.jsonData, this.props.userData.RUT));
  }

  renderDocument = (nmbDcto, property, titulo) => {
    let list = [];
    if (Array.isArray(nmbDcto)) {
      nmbDcto.forEach((d) => {
        list.push({ Nombre: d });
      });
    } else if (typeof (nmbDcto) === "string") {
      list.push({ Nombre: nmbDcto })
    }

    return (
      <React.Fragment>
        <div style={{ marginBottom: 10, marginTop: 10 }}>
          <span className="title">{titulo}</span>
          <List
            className="draf-document-list"
            scrollByContent
            selectedIndex={2}
            noDataText="Sin documentos"
            items={list}
            itemComponent={(item) => (
              <div className="list-document-wrapper">
                <div className="text">
                  <span className="text"><i className="material-icons" style={{ fontSize: 10 }} > attach_file </i> {item.Nombre}</span>
                </div>


              </div>
            )}
          />
        </div >
      </React.Fragment>
    );
  }
  render() {
    const formInfoTrabajador = this.props.jsonData.formInfoTrabajador;
    const formInfoLaboral = this.props.jsonData.formInfoLaboral;
    const formInfoPrevisional = this.props.jsonData.formInfoPrevisional;
    const monthsDisplay = this.props.jsonData.monthsDisplay;

    return (

      <div className="row">

        <div className="col-12 newDenuncia-title" ref={this.topRef}>
          <h2>Resumen</h2>

        </div>

        <div className="col-12 newDenuncia-title">
          <h2>Información del trabajador</h2>
        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Datos trabajador</h4>
          <TextField
            label="Rut"
            disabled
            id="Rut"
            value={formInfoTrabajador.Rut}

          />


          <TextField
            label="Nombre trabajador"
            disabled
            id="Nombre"
            value={`${formInfoTrabajador.FirstName}${formInfoTrabajador.LastName}`}

          />
          <TextField
            label="Correo electrónico"
            id="email"
            value={formInfoTrabajador.email}
            disabled
          />


        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Contrato de trabajo</h4>

          <DateField
            label="Fecha de contratación del trabajador"
            id="fechaContrato"
            value={formInfoTrabajador.fechaContrato}
            disabled
            type="date"
          />

          {
            formInfoTrabajador.contratoTrabajo && this.renderDocument(formInfoTrabajador.contratoTrabajo, "contratoTrabajo", "Contrato de trabajo")
          }


        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Retenciones judiciales del trabajador</h4>

          <RadioGroupfield
            label="El trabajador tiene retenciones judiciales"
            items={["Si", "No"]}
            id="RetencionesJudiciales"
            value={formInfoTrabajador.RetencionesJudiciales}
            onValueChanged={this.handleChange}
            disabled
            layout="horizontal"
          />

          {formInfoTrabajador.RetencionesJudiciales === "Si" &&
            this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(formInfoTrabajador.oficio, "oficio", "Retenciones judiciales")
          }

        </div>

        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Medio de pago trabajador</h4>
          <SelectField
            label="Medio de pago"
            id="FormaPago"
            value={formInfoTrabajador.FormaPago}
            disabled
            items={["Transferencia electrónica", "Vale Vista"]}
          />

          <SelectField
            label="Banco"
            id="Bank"
            value={formInfoTrabajador.Bank}
            dataSource={this.props.listaBancos}
            displayExpr="Banco"
            valueExpr="Codigo"
            disabled
          />
          {
            formInfoTrabajador.FormaPago !== "Vale Vista" &&
            <React.Fragment>
              <TextField
                label="Número de cuenta"
                id="AccountNumber"
                disabled
                value={`${formInfoTrabajador.AccountNumber}`}
              />
            </React.Fragment>
          }

        </div>

        {this.props.jsonData.middleStepsEnabled &&
          <React.Fragment>
            <div className="col-12 newDenuncia-title" >
              <h2>Información laboral</h2>
            </div>

            <div className="col-12">
              <h4 className="newDenuncia-subtitle">{monthsDisplay[0]}</h4>
              <TextField
                label={`Dias Trabajados en ${monthsDisplay[0]}`}
                id="DiasTrabajadosMesUno"
                value={formInfoLaboral.DiasTrabajadosMesUno || 0}
                disabled
              />

              {parseInt(formInfoLaboral.DiasTrabajadosMesUno, 10) <= 26 ?
                <React.Fragment>
                  <TextField
                    label={`Motivo de ausencia ${monthsDisplay[0]}`}
                    id="motivoAusenciaMesUno"
                    value={formInfoLaboral.motivoAusenciaMesUno || null}
                    disabled
                  />

                  {
                    formInfoLaboral.adjuntoJustificacionMesUno && formInfoLaboral.adjuntoJustificacionMesUno.length > 0 && this.renderDocument(formInfoLaboral.adjuntoJustificacionMesUno, "adjuntoJustificacionMesUno", `Documentos justificación de ${monthsDisplay[0]}`)
                  }
                </React.Fragment>
                : ""
              }
              {
                this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(formInfoLaboral.adjuntoLiquidacionMesUno, "adjuntoLiquidacionMesUno", `Liquidación de ${monthsDisplay[0]}`)
              }
            </div>
          </React.Fragment>
        }
        {monthsDisplay.length >= 2 ?

          <div className="col-12">
            <h4 className="newDenuncia-subtitle">{monthsDisplay[1]}</h4>
            <TextField
              label={`Dias Trabajados en ${monthsDisplay[1]}`}
              id="DiasTrabajadosMesDos"
              value={formInfoLaboral.DiasTrabajadosMesDos || 0}
              disabled
            />
            {parseInt(formInfoLaboral.DiasTrabajadosMesDos, 10) <= 22 ?
              <React.Fragment>
                <TextField
                  label={`Motivo de ausencia ${monthsDisplay[1]}`}
                  id="motivoAusenciaMesDos"
                  value={formInfoLaboral.motivoAusenciaMesDos || null}
                  disabled
                />

                {
                  formInfoLaboral.adjuntoJustificacionMesDos && formInfoLaboral.adjuntoJustificacionMesDos.length > 0 && this.renderDocument(formInfoLaboral.adjuntoJustificacionMesDos, "adjuntoJustificacionMesUno", `Documentos justificación de ${monthsDisplay[1]}`)
                }
              </React.Fragment>
              :
              ""

            }

            {
              this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(formInfoLaboral.adjuntoLiquidacionMesDos, "adjuntoLiquidacionMesDos", `Liquidación de ${monthsDisplay[1]}`)
            }
          </div>
          : ""
        }
        {monthsDisplay.length === 3 ?

          <div className="col-12">
            <h4 className="newDenuncia-subtitle">{monthsDisplay[2]}</h4>
            <TextField
              label={`Dias Trabajados en ${monthsDisplay[2]}`}
              id="DiasTrabajadosMesTres"
              value={formInfoLaboral.DiasTrabajadosMesTres || 0}
              disabled
            />
            {parseInt(formInfoLaboral.DiasTrabajadosMesTres, 10) <= 22 ?
              <React.Fragment>
                <TextField
                  label={`Motivo de ausencia ${monthsDisplay[2]}`}
                  id="motivoAusenciaMesTres"
                  value={formInfoLaboral.motivoAusenciaMesTres || null}
                  disabled
                />


                {
                  formInfoLaboral.adjuntoJustificacionMesTres && formInfoLaboral.adjuntoJustificacionMesTres.length > 0 && this.renderDocument(formInfoLaboral.adjuntoJustificacionMesTres, "adjuntoJustificacionMesUno", `Documentos justificación de ${monthsDisplay[2]}`)
                }
              </React.Fragment>
              :
              ""

            }

            {
              this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(formInfoLaboral.adjuntoLiquidacionMesTres, "adjuntoLiquidacionMesTres", `Liquidación de ${monthsDisplay[2]}`)
            }
          </div>
          :
          ""
        }



        {
          <React.Fragment>
            <div className="col-12 newDenuncia-title" >
              <h2>Información del Previsional</h2>
            </div>
            <div className="col-12">
            <SelectField
              label="Previsón de salud"
              id="tipoPervisionSaludMesTres"
              disabled
              value={formInfoPrevisional && formInfoPrevisional.tipoPervisionSaludMesTres ? formInfoPrevisional.tipoPervisionSaludMesTres : null}
              items={["Isapre", "Fonasa", "Capredena"]}
            />
            {formInfoPrevisional.tipoPervisionSaludMesTres !== "Fonasa"
              && formInfoPrevisional.tipoPervisionSaludMesTres !== "Capredena" ?
              <React.Fragment>
                <SelectField
                  label="Isapre"
                  id="codigoPrevisionMesTres"
                  value={formInfoPrevisional.codigoPrevisionMesTres}
                  dataSource={this.props.listaIsapres}
                  displayExpr="Isapre"
                  valueExpr="CodigoIsapre"
                  disabled
                />
                <div className="row zero-vertical">
                  <div className="col-8 zero-right">
                    <TextField
                      label="Valor Plan"
                      id="valorPlanMesTres"
                      disabled
                      value={formInfoPrevisional.valorPlanMesTres || 0}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-4">
                    <SelectField
                      label="Unidad"
                      id="unidadMesTres"
                      value={formInfoPrevisional.unidadMesTres}
                      disabled
                      items={["UF", "Pesos", "UTM"]}
                    />

                  </div>
                </div>
                {
                  this.props.listaDocumentosIngresados && this.props.listaDocumentosIngresados.length > 0 && this.renderDocument(formInfoPrevisional.adjuntoAfiliacionMesTres, "adjuntoAfiliacionMesTres", `Documento afiliación de ${monthsDisplay[2]}`)
                }
              </React.Fragment>
              :
              ""
            }

            <SelectField
              label="AFP"
              id="afpMesTres"
              value={formInfoPrevisional && formInfoPrevisional.afpMesTres ? formInfoPrevisional.afpMesTres : null}
              dataSource={this.props.listaAfp}
              displayExpr="Text"
              valueExpr="Cod"
              disabled
            />

          </div>

          </React.Fragment>
        }




        <div className="col-12">
          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Enviar"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />
        </div>

      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  jsonData: state.prestacionesEmpresa.jsonData,
  middleStepsEnabled: state.prestacionesEmpresa.middleStepsEnabled,
  listaBancos: state.global.listaBancos,
  listaAfp: state.global.listaAfp,
  listaTiposCuenta: state.global.listaTiposCuenta,
  listaIsapres: state.global.listaIsapres,
  userData: state.global.userData,
  listaDocumentosIngresados: state.prestacionesEmpresa.listaDocumentosIngresados,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EnviarDocumento);
